'use client';
import './styles/@theme';
import { useEffect, useState } from 'react';
import type { GameViewModel } from '@/types/games';
import { getText } from '@/utils/text/text';
import { getRecommendedGames } from '@/logic/games/recommended-games';
import { RecommendedGamesReadySentinel } from './recommended-games-ready-sentinel.client';
import { GameFactoryClient } from '@/app/components/game/game-factory.client';

export const RecommendedGames: React.FC = () => {
    const [games, setGames] = useState<GameViewModel[]>([]);

    useEffect(() => {
        getRecommendedGames().then((fetchedGames) => setGames(fetchedGames));
    }, []);

    if (!games.length) {
        return <RecommendedGamesReadySentinel tilesCount={0} />;
    }

    const headerText = getText({
        text: 'components.search.searchBrandText'
    });

    return (
        <div
            className="recommended-games"
            data-t-module="search_recommended"
            data-t-zonename="search_results___our_recommended_games">
            <p className="recommended-games_header">{headerText}</p>
            <div className="recommended-games_container">
                {games.map((game, index) => (
                    <GameFactoryClient
                        key={game.uid}
                        game={game}
                        tracking={{
                            gamePosition: index
                        }}
                    />
                ))}
            </div>
            <RecommendedGamesReadySentinel tilesCount={games.length} />
        </div>
    );
};
